import { createPortal } from "react-dom";
import Confetti from "react-confetti";

/**
 * Renders a react-confetti canvas portal'd to document.body.
 * Passes all props through to the Confetti component (e.g. run, recycle, numberOfPieces).
 *
 * @param {Object} props - Props forwarded to react-confetti's <Confetti />.
 * @returns {React.ReactPortal} A portal rendering the confetti overlay.
 */
export default function PortalConfetti(props) {
  return createPortal(<Confetti {...props} />, document.body);
}
